import React from "react";
import IntelligenceWorkspaceShell from "./IntelligenceWorkspaceShell";

export default function OperationalHealth({ children }) {
  return (
    <IntelligenceWorkspaceShell
      workspaceKey="operational"
      eyebrow="Operational intelligence"
      title="Operational Health"
      description="People, workload, coverage and response health."
    >
      {children}
    </IntelligenceWorkspaceShell>
  );
}
